import { render } from "./AllergensView.vue?vue&type=template&id=9f0d5650&scoped=true&ts=true"
import script from "./AllergensView.vue?vue&type=script&lang=ts"
export * from "./AllergensView.vue?vue&type=script&lang=ts"

import "./AllergensView.vue?vue&type=style&index=0&id=9f0d5650&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f0d5650"]])

export default __exports__